import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import CheckInCircleIcon from 'components/SvgIcons/ComplexIcons/check-in-circle.svg';
import CrossInCircleIcon from 'components/SvgIcons/ComplexIcons/cross-in-circle.svg';

import './yesno.scss';

export const YesNo = (props) => {
  const { value, className } = props;

  if (value !== true && value !== false) {
    return null;
  }

  return (
    <div
      className={cns(`yes-no-wrapper ${className}`, {
        'yes-no-wrapper__no': !value,
      })}
    >
      {value ? (
        <React.Fragment>
          <CheckInCircleIcon width="14px" height="14px" className="mr-1" />
          <span className="yes-no-title">Yes</span>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <CrossInCircleIcon width="14px" height="14px" className="mr-1" />
          <span className="yes-no-title">No</span>
        </React.Fragment>
      )}
    </div>
  );
};

YesNo.propTypes = {
  value: PropTypes.bool,
  className: PropTypes.string,
};

YesNo.defaultProps = {
  value: null,
  className: '',
};
